import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import {BehaviorSubject, Observable} from "rxjs";
import {ApiResponse, handleError} from "../utils";
import {
  addAdoptActionPointAnonymous,
  addRatingAnonymous,
  getCommentListAnonymous, getSharedPost,
  getSingleActionPointAnonymous,
  getSinglePostAnonymous,
  likeActionPointAnonymous,
  removeAdoptActionPointAnonymous,
  viewRatingStatisticsAnonymous
} from "../variables";
import {catchError} from "rxjs/operators";
import {AuthService} from "../auth/auth.service";
import {PostModel} from "../../models/post.model";
import {GlobalService} from "../global/global.service";

@Injectable({
  providedIn: 'root'
})
export class AnonymousService {
  public postEvent = new BehaviorSubject<PostModel>(null);
  public postSubject: Observable<PostModel> = this.postEvent.asObservable();

  public simpleHeader = {
    'content-type': 'application/json',
    'x-deviceId': ''
  }
  constructor(
    private globalService: GlobalService,
    public auth: AuthService,
    public http: HttpClient
  ) {}

  apiGetSinglePostAnonymous(id): Observable<ApiResponse> {
    return this.http.get<ApiResponse>( getSinglePostAnonymous + '/' + id, {headers: this.simpleHeader}).pipe(
      catchError(handleError)
    );
  }
  apiGetSingleActionPointAnonymous(id): Observable<ApiResponse> {
    return this.http.get<ApiResponse>( getSingleActionPointAnonymous + '/' + id, {headers: this.simpleHeader}).pipe(
      catchError(handleError)
    );
  }
  apiGetSharedPost(id): Observable<ApiResponse> {
    return this.http.get<ApiResponse>( getSharedPost + '/' + id, {headers: this.simpleHeader}).pipe(
      catchError(handleError)
    );
  }
  viewRatingStatisticsAnonymous(id): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(viewRatingStatisticsAnonymous + '/' + id, {headers: this.simpleHeader}).pipe(
      catchError(handleError),
    );
  }

  apiLikeActionPoint(data): Observable<ApiResponse> {
    data.referrer = this.globalService.lastRoute;
    return this.http.post<ApiResponse>(likeActionPointAnonymous, data, {headers: this.simpleHeader}).pipe(
      catchError(handleError)
    );
  }

  apiAddAdoptActionPointAnonymous(data): Observable<ApiResponse> {
    data.referrer = this.globalService.lastRoute;
    return this.http.post<ApiResponse>(addAdoptActionPointAnonymous, data, {headers: this.simpleHeader}).pipe(
      catchError(handleError)
    );
  }
  apiRemoveAdoptAPAnonymous(data): Observable<ApiResponse> {
    data.referrer = this.globalService.lastRoute;
    return this.http.post<ApiResponse>(removeAdoptActionPointAnonymous, data, {headers: this.simpleHeader}).pipe(
      catchError(handleError)
    );
  }

  apiAddRatingAnonymous(data): Observable<ApiResponse> {
    data.referrer = this.globalService.lastRoute;
    return this.http.post<ApiResponse>(addRatingAnonymous, data, {headers: this.simpleHeader}).pipe(
      catchError(handleError)
    );
  }

  apiGetComments(id, pagination): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(getCommentListAnonymous + '/' + id + '?page=' + pagination, {headers: this.simpleHeader}).pipe(
      catchError(handleError),
    );
  }
}
